export const productName = 'MEGAPACK PETRÓLEO Y GAS LISTO';
export const productShortName = 'Megapack Petróleo y Gas Listo';
export const productImage = 'https://cdn.magicpatterns.com/uploads/1zA6dmUv6JrsTAKByiGuJY/MOCKUP.png';

export const checkoutUrl = 'https://megapack-petroleo-y-gas-listo.impultienda.ar/checkout';

export const price = 'USD 19,00';
export const priceBefore = 'USD 40,00';

export const totalVolumes = 9;
export const totalBonuses = 5;
export const bonusTotalValue = 'USD 70,00';

export const included = [
  'Tomo 1 — Fundamentos del Petróleo y Gas',
  'Tomo 2 — Geología del Petróleo y Sistemas Petroleros',
  'Tomo 3 — Exploración de Petróleo y Gas',
  'Tomo 4 — Perforación y Construcción de Pozos',
  'Tomo 5 — Producción de Petróleo y Gas',
  'Tomo 6 — Refinación de Petróleo y Procesamiento de Gas Natural',
  'Tomo 7 — Transporte, Almacenamiento y Distribución de Petróleo y Gas',
  'Tomo 8 — Seguridad, Gestión de Riesgos y Medio Ambiente',
  'Tomo 9 — Enseñanza del Petróleo y Gas: Estrategias, Actividades y Proyectos Educativos 2026',
  'Bono 1 — 150 Actividades y Desafíos',
  'Bono 2 — Kit de Evaluación Completo',
  'Bono 3 — 100 Casos y Situaciones Problemáticas',
  'Bono 4 — Diccionario Docente de 200 Conceptos',
  'Bono 5 — 100 Preguntas y Temas de Debate',
  'Garantía de 7 días sin preguntas',
  'Acceso inmediato',
];

export const systemNegatives = [
  'No es teoría copiada de un manual desactualizado.',
  'No es una colección de actividades sueltas sin coherencia.',
  'No es material que tengas que adaptar entero.',
];

export const closingLines = [
  'Sin más noches buscando cómo explicar conceptos de petróleo y gas complejos',
  'Sin más clases armadas de apuro con material que no funciona',
  'Sin más alumnos desconectados que no entienden para qué sirve la industria petrolera',
  'Sin más fines de semana perdidos construyendo material desde cero',
  'Sin más silencios incómodos frente a preguntas técnicas que te ponen en aprietos',
];
